<template>
  <div class="main-cover-container" :style="containerStyle">
    <b-overlay :show="theme_option === null" no-wrap />

    <b-img
      id="sb-logo-img"
      class="navbar-sb-logo position-absolute d-print-block d-none"
      style="top: 5vh; left: 10vw; z-index: 1000"
      :src="$store.state.static_host + selected_report.logo_path"
    />
    <div
      v-if="theme_option"
      class="overlay"
      :class="[horizontalClass, verticalClass]"
      :style="backgroundImageStyle"
    >
      <div class="hero-title" :class="is_full_image ? 'padded-container' : 'pl-6'">
        <h2
          v-if="lang === 'KOR'"
          class="mb-1 title-en"
          :style="subTitleStyle"
          :class="horizontalTextClass"
        >
          {{ selected_report?.report_subname }}
        </h2>

        <h1
          id="title_web-report-title"
          class="fw-800 px-lg-0 title-kr"
          :class="horizontalTextClass"
          :style="titleStyle"
        >
          <span v-if="lang === 'KOR'">
            {{ selected_report?.report_name }}
          </span>
          <span v-else>
            {{ selected_report?.report_name_e }}
          </span>
        </h1>

        <p class="mt-1 title-en" :style="DateStyle" :class="horizontalTextClass">
          {{ selected_report.start_date }} ~ {{ selected_report.end_date }}
          <br />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'StoryBoardMain',
  props: {
    mp4Url: { type: String, default: null },
    imageUrl: { type: String, default: null },
    print_mode: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_contents', ['theme_option']),
    is_full_image() {
      return this.theme_option?.sb_theme_info?.is_full_image || false;
    },

    containerStyle() {
      return {
        marginTop: this.isCustomCssEditor || this.print_mode ? '0px' : '90px',
        height: this.print_mode
          ? 'calc(100vh)'
          : this.is_full_image
          ? 'calc(100vh - 90px)'
          : 'calc(100vh - 140px)'
      };
    },

    backgroundImageStyle() {
      if (this.mp4Url) {
        return {
          background: `url(${this.mp4Url}) center center / cover no-repeat`
        };
      } else if (this.imageUrl) {
        return {
          background: `url(${this.imageUrl}) center center / cover no-repeat`
        };
      } else {
        return {
          backgroundColor: this.selected_report.main_color,
          minHeight: 'auto',
          width: '100%'
        };
      }
    },
    titleStyle() {
      if (this.theme_option?.theme_info) {
        return {
          fontSize: `${this.theme_option?.theme_info?.title_size}rem`,
          fontFamily: `${this.theme_option?.theme_info?.title_font}`,
          color: `${this.theme_option?.theme_info?.title_color}`
        };
      } else {
        return null;
      }
    },
    subTitleStyle() {
      if (this.theme_option?.theme_info) {
        return {
          fontSize: `${parseFloat(this.theme_option?.theme_info?.title_size) / 2}rem`,
          fontFamily: `${this.theme_option?.theme_info?.title_font}`,
          color: `${this.theme_option?.theme_info?.title_color}`
        };
      } else {
        return null;
      }
    },
    DateStyle() {
      if (this.theme_option?.theme_info) {
        return {
          fontSize: `${parseFloat(this.theme_option?.theme_info?.title_size) / 3}rem`,
          fontFamily: `${this.theme_option?.theme_info?.title_font}`,
          color: `${this.theme_option?.theme_info?.title_color}`
        };
      } else {
        return null;
      }
    },
    horizontalClass() {
      const config = this.theme_option?.theme_info?.title_horizontal_config;
      return config === 'left'
        ? 'justify-content-start'
        : config === 'center'
        ? 'justify-content-center'
        : 'justify-content-end';
    },
    verticalClass() {
      const config = this.theme_option?.theme_info?.title_vertical_config;
      return config === 'top'
        ? 'align-items-start'
        : config === 'center'
        ? 'align-items-center'
        : 'align-items-end';
    },
    horizontalTextClass() {
      const config = this.theme_option?.theme_info?.title_horizontal_config;
      return config === 'left' ? 'text-left' : config === 'center' ? 'text-center' : 'text-right';
    },

    isCustomCssEditor() {
      return this.$route.path === '/custom_css_editor';
    }
  }
};
</script>

<style lang="scss" scoped>
.main-cover-container {
  position: relative;
  width: 100%;
  min-height: 250px;
  margin-bottom: 100px;
}

.main-cover {
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 250px;
  display: flex;
  padding-top: 20vh;
  padding-bottom: 20vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: cover;
}

.hero-title {
  position: relative;
  color: white;
  z-index: 2;
}

.title-kr {
  line-height: 1.2;
  letter-spacing: -0.01px;
}
</style>
